import { render, staticRenderFns } from "./MyBuddiesView.vue?vue&type=template&id=4a097200&scoped=true&"
import script from "./MyBuddiesView.vue?vue&type=script&lang=ts&"
export * from "./MyBuddiesView.vue?vue&type=script&lang=ts&"
import style0 from "./MyBuddiesView.vue?vue&type=style&index=0&id=4a097200&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a097200",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VBtn,VContainer})
